const PROPERTY_PROPERTY = 'property';

export class WebWalk {
	constructor(CommonConstants) {
		'ngInject';
		this.constants = CommonConstants;
	}

	hasWebWalk(property) {
		for (let i = 0; i < property.images.length; i++) {
			if (property.images[i][this.constants.WEBSETA_PROPERTY]) {
				property.hasWebWalk = true;
				return;
			}
		}
		property.hasWebWalk = false;
	}

	setWebWalkProperty(propertyArray) {
		if (propertyArray.length) {
			if (propertyArray[0].hasOwnProperty(PROPERTY_PROPERTY)) {
				for (let i = 0; i < propertyArray.length; i++) {
					this.hasWebWalk(propertyArray[i].property);
				}
			} else {
				for (let i = 0; i < propertyArray.length; i++) {
					this.hasWebWalk(propertyArray[i]);
				}
			}
		}
	}

	checkWebWalkForEstate(property) {
		this.hasWebWalk(property);
	}
}

